export const getConfig = (key) =>
{
    let appKey = 'REACT_APP_' + key;
    if (appKey in process.env)
    {
        return process.env[appKey];
    }
};

export const googleMapUrl = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=directions,places&key=" + getConfig('GOOGLE_API_KEY');


// WEBPACK FOOTER //
// ./src/classes/Config.js